<audio #audioPlayer></audio>

<div
  class="time-range"
  nz-tooltip
  [nzTooltipTitle]="range.message | truncate"
  [nzTooltipColor]="'#4caf50'"
  [style.left]="leftPx"
  [style.width]="widthPx"
  (click)="onRangeClick()"
></div>

<nz-modal
  [nzWidth]="'80%'"
  [(nzVisible)]="isPopoverVisible"
  [nzTitle]="undefined"
  [nzCancelText]="'Close'"
  (nzOnCancel)="handleCancel()"
  [nzOkText]="null"
>
  <ng-container *nzModalContent>
    <div class="vertical popover-body margin-top">
      <div class="vertical no-gap">
        <div class="original-section">
          {{ range.message }}
        </div>
      </div>

      <div class="vertical">
        <div class="horizontal">
          <button class="fit-content" nz-button nzType="primary" nzSize="large" (click)="onPlayClick()">
            <span nz-icon style="font-size: 16px" class="material-symbols-rounded">play_circle</span>
            Play Audio
          </button>

          <button class="fit-content" nz-button nzType="default" nzSize="large" (click)="onFindObjectionClick()">
            Find Objection
          </button>
        </div>

        @if (feedbackRange) {
          <app-feedback-improvements
            [session]="session"
            [index]="feedbackIndex"
            [range]="feedbackRange"
            [sessionMessageList]="sessionMessageList"
          ></app-feedback-improvements>
        }
        <!-- <button class="fit-content" nz-button nzType="primary" nzSize="small" (click)="onPlayClick()">
          <span nz-icon style="font-size: 16px" class="material-symbols-rounded">replay</span>
          Retry to answer
        </button> -->
      </div>
    </div>
  </ng-container>
</nz-modal>
